import * as React from 'react';
import PropTypes from 'prop-types';
import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { Dialog, DialogContent, styled } from '@mui/material';
import { API_BASE_URL, PROGRESS_BAR_DETAILS_API } from '../../Utils/Config';
import { getRequest, postRequest } from '../../Services/AxiosConfiguration';
import { useSelector } from 'react-redux';


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
      padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
      padding: theme.spacing(1),
    },
  }));


function LinearProgressWithLabel(props:any) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', height:'100px', width:'200px', marginLeft:'35%', padding:'2%' }}>
      <Box sx={{ width: '100%', mr: 1 }}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
      <Box sx={{ minWidth: 35 }}>
        <Typography variant="body2" color="text.secondary">{`${Math.round(
          props.value,
        )}%`}</Typography>
      </Box>
    </Box>
  );
}

LinearProgressWithLabel.propTypes = {
  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: PropTypes.number.isRequired,
};

function Loader() {
  const [progress, setProgress] = React.useState(10);
  const [progressData, setProgressData] = React.useState([]);
  const selectedUsecaseId = useSelector(
    (state: any) => state.InputDataReducers.selectedUsecaseId
  );

  const selectedCategoryIdd = useSelector(
    (state: any) => state.InputDataReducers.selectedCategoryId
  );

  const selectedFolderId = useSelector(
    (state: any) => state.InputDataReducers.selectedFolderId);


    const selectedScenarioId = useSelector(
        (state: any) => state.InputDataReducers.selectedScenarioId
    
      );

      const params = {
        "usecaseId": 1,
  "category_id": 2,
  "folder_id": 100,
  "scenario_id": 0
      }
  React.useEffect(() => {
    const urls = API_BASE_URL + PROGRESS_BAR_DETAILS_API;
    postRequest(urls,params, {} ).then((response) => {
        if (response.status === 200 && response) {
            console.log(response.data.data, "dfadasfada");
            setProgressData(response.data);
        }}).catch((error) => {
          });
    const timer = setInterval(() => {
      setProgress((prevProgress) => (prevProgress >= 100 ? 10 : prevProgress + 10));
    }, 10000);
    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    // <BootstrapDialog
    //       //onClose={props.handleCloseDonePopup}
    //       aria-labelledby="customized-dialog-title"
    //       //open={props.isOpenDone}
    //       className="done-modal" open={false}  >
    // {/* <Box sx={{ width: '80%' }}>
    //   <LinearProgressWithLabel value={progress} />
    // </Box> */}
    //  <DialogContent className="done-modal-body">
    //       <div>
    //         <Box sx={{ width: '80%' }}>
    //   <LinearProgressWithLabel value={progress} />
    // </Box>
    //       </div>
    //     </DialogContent>
    // </BootstrapDialog>
    <Box sx={{ width: '80%' }}>
      <LinearProgressWithLabel value={progress} />
    </Box>
  );
}
export default Loader;